// frontend/src/components/technician/TechnicianPrivateRoute.js

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Build } from '@mui/icons-material';
import { useTechnicianAuth } from '../../contexts/TechnicianAuthContext';

const TechnicianPrivateRoute = ({ children }) => {
    const { technician, loading, technicianToken } = useTechnicianAuth();
    const location = useLocation();

    console.log('TechnicianPrivateRoute - Estado:', {
        loading,
        hasToken: !!technicianToken,
        hasTechnician: !!technician,
        technicianName: technician?.name
    });

    // Mostrar spinner mientras se verifica la autenticación
    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    bgcolor: 'background.default'
                }}
            >
                <Build sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                <Typography variant="h6" gutterBottom color="primary">
                    YinoWisp Portal Técnico
                </Typography>
                <CircularProgress size={40} />
                <Typography variant="body2" sx={{ mt: 2 }} color="textSecondary">
                    Verificando credenciales...
                </Typography>
            </Box>
        );
    }

    // CORREGIDO: Verificar tanto token como datos del técnico
    if (!technicianToken || !technician) {
        console.log('TechnicianPrivateRoute - Redirigiendo a login, motivo:', {
            noToken: !technicianToken,
            noTechnician: !technician
        });

        return (
            <Navigate
                to="/technician/login"
                state={{ from: location }}
                replace
            />
        );
    }

    // Si está autenticado, mostrar el contenido
    console.log('TechnicianPrivateRoute - Acceso autorizado para:', technician.name);
    return children;
};

export default TechnicianPrivateRoute;